import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import style from './Home.module.scss';
import Container from "react-bootstrap/Container";
import * as Components from './components/index';

class Home extends React.Component {
  render() {
    return (
        <Container fluid className={`p-0`}>
          <div className={style.section_1}>
            <div className={`${style.shadow}`} />
            <Components.Menu />
            <div className={`${style.search_container}`}>
              <div className={'search-container'}>
                <Components.Search />
              </div>
            </div>
          </div>
          <div className={style.section_2}>
            <Container fluid={"md"}>
              <Components.OurServices />
            </Container>
            <Container fluid={"md"} className={`${style.about_us}`}>
              <Components.AboutUs />
            </Container>
            <Container fluid={"md"} className={`${style.advisor}`}>
              <Components.Advisor />
            </Container>
          </div>
          <div className={`${style.section_3}`}>
            <Container fluid={"md"} className={`${style.announcement}`}>
              <Components.Announcement />
            </Container>
          </div>
        </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(undefined, mapDispatchToProps)(withRouter(Home));
